import { config } from "/app.config";
import { i18n } from "@/plugins/i18n";

export default config.automation
  ? [
      {
        name: "station.automation",
        path: "automation",
        component: () => import("@/views/Stations/StationAutomation.vue"),
        meta: {
          pageTitle: i18n.t("route.page_title.account.station.automation"),
          parent: "stations",
          rule: "owner",
        },
      },
    ]
  : [];
